import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
  VStack,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { REPOSITORY } from '../../../../api/repository/Repository'
import Table from '../../../../components/Table/Table'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { columns } from './temporalData'
import SvgIcon from './../../../../components/SvgIcon/SvgIcon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faX } from '@fortawesome/free-solid-svg-icons'
import useOrder from '../../../../utils/hooks/useOrder/useOrder'

export default function Nominative() {
  const { orderAsc, orderBy, onSort } = useOrder()

  const { texts } = useLabels()
  // const navigate = useNavigate()
  const [accounts, setAccounts] = useState([])
  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({
    actualPage: 1,
    nEmpleadosPagina: 30,
    totalPages: 0,
  })

  const handleAccounts = async (newPage) => {
    let sort = {}

    if (orderBy) {
      if (orderBy === 'NOMBRE') {
        sort = {
          sOrderby: 'sNombre',
          bAsc: orderAsc,
        }
      } else if (orderBy === 'RUT') {
        sort = {
          sOrderby: 'sRUT',
          bAsc: orderAsc,
        }
      }
    }

    const data = await REPOSITORY.wsEmpresa.employees.accountsRequested({
      sTipoEmpleado: 'NO',
      sBusqueda: search.trim().replaceAll(/\./g, '').replaceAll(/-/g, ''),
      nPagina: newPage ?? 1,
      nEmpleadosPagina: 20,
      bAsc: false,
      ...sort,
    })
    setPagination((prevState) => ({
      ...prevState,
      actualPage: data.nPagina,
      totalPages: data.nPaginasTotal,
    }))
    setAccounts(data.DatosCuentaSolicitada)
  }

  const handleChangeSearch = (event) => {
    setSearch(event.target.value)
  }
  const handleClearSearch = () => {
    setSearch('')
    handleAccounts(1)
  }
  const handleChangePage = (newPage) => {
    setPagination((prevState) => ({ ...prevState, actualPage: newPage }))
  }
  const handleSearch = () => {
    handleAccounts(1)
  }
  useEffect(() => {
    handleAccounts(pagination.actualPage)
  }, [pagination.actualPage, orderAsc, orderBy])
  return (
    <Flex direction="column" mb="80px">
      <Box>
        <UnderlineHeading text={'Acciones'} variant="h5" />
      </Box>
      <Box h="66px" w="320px" mt="24px">
        <Link to="partner-register">
          <Button
            variant="secondary"
            borderRadius="6px"
            boxShadow={'0px 12px 16px rgba(0, 0, 0, 0.25)'}
            width={'320px'}
            height={'66px'}
            // onClick={() => navigate('partner-register')}
          >
            <HStack>
              <SvgIcon iconName="userAdd" color={'#FFFFFF'} />
              <Text variant="semibold" color="#FFFFFF">
                {texts.partner_register}
              </Text>
            </HStack>
          </Button>
        </Link>
      </Box>
      <Box mb={'24px'} mt="24px">
        <UnderlineHeading text={'Bolsillos solicitados'} variant="h5" />
      </Box>
      <VStack alignItems={'flex-start'} spacing={4}>
        <HStack width={'100%'}>
          <Box>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <FontAwesomeIcon icon={faSearch} />
              </InputLeftElement>
              <Input
                placeholder="Ingresa RUT"
                value={search}
                onChange={handleChangeSearch}
              />
              {search.length > 0 && (
                <InputRightElement
                  cursor={'pointer'}
                  onClick={handleClearSearch}
                >
                  <FontAwesomeIcon icon={faX} />
                </InputRightElement>
              )}
            </InputGroup>
          </Box>
          <Box>
            <Button onClick={handleSearch} variant={'ghost'}>
              Buscar
            </Button>
          </Box>
        </HStack>
        <Table
          orderAsc={orderAsc}
          orderBy={orderBy}
          onSort={onSort}
          data={accounts}
          columns={columns}
          paginationProps={{
            ...pagination,
            handlePageChange: handleChangePage,
          }}
          withPagination
        />
      </VStack>
    </Flex>
  )
}
